import React from 'react'

export default ({ width, height }) => (
  <svg
    width={width || '25'}
    height={height || '18'}
    viewBox="0 0 25 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#454545" fill="none" fillRule="evenodd">
      <path d="M1 14.35v.72c0 1.047.855 1.896 1.91 1.896h19.065c1.055 0 1.91-.85 1.91-1.896V2.896C23.886 1.85 23.03 1 21.976 1H2.91C1.855 1 1 1.85 1 2.896v7.53" />
      <path d="M1 4.556l11.455 3.958L23.91 4.556" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/emailIcon.js